var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"Privacy Policy","subtitle":"Last updated: August 2026","intro":"This page explains how gbmodshub.net handles information when you browse the site or send an email.","sections":_vm.sections,"email":"contact@gbmodshub.net","page-name":"privacy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }